import {
  defaultWebBlePrintSettings,
  webBlePrintersSlice,
  type WebBlePrintersState,
  type WebBlePrintSettings,
} from '@store/slices/webBlePrinters';
import { useAppDispatch, useAppSelector } from '..';

// El reducer está registrado bajo la key `webBlePrinters` en `store/index.ts` (y
// añadido a DEVICE_SCOPED_SLICES para sobrevivir al resetStore del login). El `?? {}`
// queda como defensa por si el slice no estuviera montado en algún entorno de test.
export const useWebBlePrintersFromStore = (): WebBlePrintersState => {
  return useAppSelector((state) => state.webBlePrinters ?? {});
};

// Impresora BLE "principal" para impresión MANUAL desde botones de pedido.
// Preferencia: primera habilitada con dispositivo emparejado (deviceId) → primera
// habilitada → primera de la lista. Devuelve `undefined` si NO hay impresoras: a
// diferencia de Electron, Web BLE puede arrancar sin ninguna emparejada (opt-in),
// y el camino de impresión debe caer al fallback pdfMake en ese caso.
export const useMainWebBlePrinter = (): WebBlePrintSettings | undefined => {
  const all = useWebBlePrintersFromStore();
  const keys = Object.keys(all);
  if (!keys.length) return undefined;
  const paired = keys.find((k) => all[k].enabled && all[k].deviceId);
  const enabled = keys.find((k) => all[k].enabled);
  return all[paired || enabled || keys[0]];
};

export const useWebBlePrintersActions = () => {
  const dispatch = useAppDispatch();

  const updateWebBlePrintSettings = (settings: Partial<WebBlePrintSettings>, printerKey: string) =>
    dispatch(webBlePrintersSlice.actions.updateWebBlePrintSettings({ settings, printerKey }));

  const addPrinter = (patch?: Partial<WebBlePrintSettings>) =>
    dispatch(webBlePrintersSlice.actions.addPrinter(patch ? { patch } : undefined));

  const removePrinter = (printerKey: string) => dispatch(webBlePrintersSlice.actions.removePrinter({ printerKey }));

  const resetPrinters = () => dispatch(webBlePrintersSlice.actions.reset());

  return { updateWebBlePrintSettings, addPrinter, removePrinter, resetPrinters };
};

// Re-export de utilidades del slice para que la UI (card WebBlePrint) construya
// defaults sin importar el slice directamente.
export { defaultWebBlePrintSettings };
